import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { throwErrorMessage } from "../../../helpers/kwikui.common.helpers";
import {
  DEFAULT_VALUES,
  VALIDATE_KEY_VALUES
} from "./animation-player.constants";
import { TKwikUIAnimationPlayerType } from "./animation-player.definitions";
import { isValidKeyValue } from "./animation-player.validation";

@Component({
  selector: "kwikui-animation-player",
  templateUrl: "./animation-player.component.html",
  styleUrls: ["./animation-player.component.scss"]
})
export class KwikUIAnimationPlayerComponent implements OnInit, OnChanges {
  @Input() config: any = DEFAULT_VALUES.config;

  @Input() id: string = DEFAULT_VALUES.id;

  @Input() player: TKwikUIAnimationPlayerType = DEFAULT_VALUES.player;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    const verifyChange = (key: string) => {
      return changes.hasOwnProperty(key) && !changes[key].firstChange;
    };

    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }

    if (verifyChange("player")) {
      this.player = changes.player.currentValue;
    }

    if (verifyChange("config")) {
      this.config = changes.config.currentValue;
    }
  }

  ngOnDestroy(): void {}

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-animation-player",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }
}
